import { EmailAlertsState } from './email-alerts-state';
import { distinctUntilChanged } from 'rxjs/operators';
import { DATA_TYPES } from './email-alerts-constants';
import { getDomain } from 'www/utils/get-domain';

let emailAlertsState = null;
class EmailAlertsApi {
    constructor() {
        this._topic == null;
        if (typeof window.sectionId !== "undefined") {
            this.setSectionId(window.sectionId.trim())
            this.setSectionName(window.sectionName.trim());
        } else if (typeof window.conceptId !== 'undefined') {
            this.setConceptId(window.conceptId.trim());
            this.setConceptName(window.conceptName.trim());
        }
        if(this.state.conceptId!=null || this.state.sectionId!=null){
            this.checkSubscription().then(data => {
                const { subscriptionCheck } = data;
                if (subscriptionCheck != null && (subscriptionCheck.topic || subscriptionCheck.section)) {
                    this.setSubscribed(true);
                }
                this.setVisible(true);
            });
        }
        else{
            this.setVisible(false);
        }
    }

    get dataType() {
        let dataType = null;
        if (this.state.scectionId != null) {
            dataType = DATA_TYPES.SECTION;
        } else if (this.state.conceptId != null) {
            dataType = DATA_TYPES.CONCEPT;
        }
        return dataType;
    }

    get state() {
        if (emailAlertsState == null) {
            emailAlertsState = new EmailAlertsState();
        }
        return emailAlertsState;
    }
    get path() {
        return `https://profreg.${getDomain('profreg')}medscape.com/px/columns`;
    }
    get topicId() {
        let topicId = null;
        if (this.dataType == DATA_TYPES.SECTION) {
            topicId = this.state.sectionId.trim();
        } else if (this.dataType == DATA_TYPES.CONCEPT) {
            topicId = this.state.conceptId.trim();
        }
        return topicId;
    }
    setSectionId(val) {
        this.state.sectionId = val;
    }
    setConceptId(val) {
        this.state.conceptId = val;
    }
    setSectionName(val) {
        this.state.sectionName = val;
    }
    setConceptName(val) {
        this.state.conceptName = val;
    }
    setSubscribed(flag) {
        this.state.isSubscribed = flag;
    }
    setVisible(flag){
        this.state.isVisible = flag;
    }
    callApi(endpoint,data=null){
        const url = `${this.path}${endpoint}`;
        return $.ajax({
            url: url,
            dataType: 'jsonp',
            data: data
        })
    }
    checkSubscription() {
        let promise = new Promise((resolve, reject) => {
            let data = null;
            if (this.state.sectionId != null) {
                data = {
                    sectionId: this.state.sectionId
                }
            } else if (this.state.conceptId != null) {
                data = {
                    conceptId: this.state.conceptId
                }
            }
            const handleResolve = (data) => {
                resolve(data);
            }

            const handleReject = (error) => {
                reject(error);
            }
            if (data == null) {
                reject("Check Subscription Error (No Section/Concept ID Found)");
            } else {

                const endpoint = `/checksubscription`;
                this.callApi(endpoint,data).then(handleResolve, handleReject);
            }
        })
        return promise;
    }
    addSubscription() {
        let promise = new Promise((resolve, reject) => {
            if (this.topicId == null) {
                reject("Add Alert Error (Missing Section/Concept ID)");
            }
            const handleResolve = (data) => {
                resolve(data);
            }
            const handleReject = (error) => {
                reject(error);
            }
            const endpoint = `/addalert/${this.dataType}/${this.topicId}`
            return this.callApi(endpoint).then(handleResolve, handleReject);
        })

        return promise;
    }

}

export { EmailAlertsApi }